import { z as zod } from "zod"

export const targetTotalRiskSchema = zod
  .number({ message: "Must be a number" })
  .positive({ message: "Must be greater than 0" })
  .max(100, { message: "Must be less than or equal to 100" })
